import { render } from "./policyReviewChecklist.vue?vue&type=template&id=6826a8ec&scoped=true"
import script from "./policyReviewChecklist.vue?vue&type=script&lang=js"
export * from "./policyReviewChecklist.vue?vue&type=script&lang=js"

import "./policyReviewChecklist.vue?vue&type=style&index=0&id=6826a8ec&scoped=true&lang=css"
import "./policyReviewChecklist.vue?vue&type=style&index=1&id=6826a8ec&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6826a8ec"]])

export default __exports__